import { memo } from "react";
import { Box, Skeleton } from "@/components";

export const RedemptionQueueSkeleton = memo(function RedemptionQueueSkeleton() {
    return (
        <div className="space-y-4">
            <Box card className="gap-4 p-4">
                <Skeleton variant="text" width={240} height={32} />
                <Skeleton variant="text" width={360} height={20} />
                <div className="flex flex-wrap gap-3">
                    <Skeleton variant="rounded" width={140} height={56} />
                    <Skeleton variant="rounded" width={140} height={56} />
                </div>
            </Box>

            <div className="space-y-3">
                {Array.from({ length: 2 }).map((_, index) => (
                    <Box key={index} card className="gap-3 p-4">
                        <div className="flex items-center justify-between gap-3">
                            <div className="space-y-2">
                                <Skeleton variant="text" width={160} height={24} />
                                <Skeleton variant="text" width={120} height={18} />
                            </div>
                            <div className="flex items-center gap-3">
                                <Skeleton variant="rounded" width={96} height={28} />
                                <Skeleton variant="text" width={140} height={18} />
                            </div>
                        </div>
                    </Box>
                ))}
            </div>
        </div>
    );
});

RedemptionQueueSkeleton.displayName = "RedemptionQueueSkeleton";
